import type { SseGenerator } from '../types';

/**
 * 片段数据
 */
export interface FragmentData {
    /**
     * 片段文本
     */
    original: string;
    /**
     * 片段索引
     */
    index: number;
}
/**
 * 翻译任务中的片段
 */
export interface TranslateFragmentInTask extends SseGenerator {
    /**
     * 翻译当前任务的指定片段
     * @param fragment 片段数据
     */
    translateFragment(fragment: FragmentData): Promise<void>;
    /**
     * 重新生成指定索引的片段
     * @param fragment 片段数据
     */
    regenerateTranslation(fragment: { index: number }): Promise<void>;
}

export const TranslateFragmentInTask = Symbol('TranslateFragmentInTask');
